import { keyBy, words } from "lodash-es";

import {
  IEquipmentCategoryItem,
  IEquipmentCategory,
  IEquipmentSubcategoryItem,
} from "Venues/types";

// Sorted equipment
export const equipmentCategoryList: IEquipmentCategoryItem[] = [
  {
    category: IEquipmentCategory.technical,
    label: "Technical Equipment",
    slug: "technical-equipment",
    categories: [
      {
        category: IEquipmentCategory.technicalForklift,
        label: "Forklift",
      },
      {
        category: IEquipmentCategory.technicalTelescopicLift,
        label: "Telescopic Lift",
      },
      {
        category: IEquipmentCategory.technicalCherrypicker,
        label: "Cherrypicker",
      },
      {
        category: IEquipmentCategory.technicalRisers,
        label: "Risers",
      },
      {
        category: IEquipmentCategory.technicalBarriers,
        label: "Barriers",
      },
    ],
  },
  {
    category: IEquipmentCategory.rigging,
    label: "Rigging",
    slug: "rigging",
    categories: [
      {
        category: IEquipmentCategory.riggingPoints,
        label: "Points",
      },
      {
        category: IEquipmentCategory.riggingHoists,
        label: "Hoists",
      },
      {
        category: IEquipmentCategory.riggingControls,
        label: "Controls",
      },
      {
        category: IEquipmentCategory.riggingTrusses,
        label: "Trusses",
      },
    ],
  },
  {
    category: IEquipmentCategory.sound,
    label: "Sound Equipment",
    slug: "sound-equipment",
    categories: [
      {
        category: IEquipmentCategory.soundMainPA,
        label: "Main PA",
      },
      {
        category: IEquipmentCategory.soundDelaySpeakers,
        label: "Delay Speakers",
      },
      {
        category: IEquipmentCategory.soundFrontfills,
        label: "Frontfills",
      },
      {
        category: IEquipmentCategory.soundInfills,
        label: "Infills",
      },
      {
        category: IEquipmentCategory.soundOutfills,
        label: "Outfills",
      },
      {
        category: IEquipmentCategory.soundPAAmplifiers,
        label: "PA Amplifiers",
      },
      {
        category: IEquipmentCategory.soundProcessing,
        label: "Processing",
      },
      {
        category: IEquipmentCategory.soundFOHDesk,
        label: "FOH Desk",
      },
      {
        category: IEquipmentCategory.soundMONDesk,
        label: "MON Desk",
      },
      {
        category: IEquipmentCategory.soundMONOutboard,
        label: "MON Outboard",
      },
      {
        category: IEquipmentCategory.soundMonitors,
        label: "Monitors",
      },
      {
        category: IEquipmentCategory.soundSidefills,
        label: "Sidefills",
      },
      {
        category: IEquipmentCategory.soundDrumfill,
        label: "Drumfill",
      },
      {
        category: IEquipmentCategory.soundMONAmplifiers,
        label: "MON Amplifier",
      },
      {
        category: IEquipmentCategory.soundMicrophones,
        label: "Microphone",
      },
      {
        category: IEquipmentCategory.soundWirelessEquipment,
        label: "Wireless Equipment",
      },
      {
        category: IEquipmentCategory.soundMicrophoneStands,
        label: "Microphone Stands",
      },
      {
        category: IEquipmentCategory.soundDJEquipment,
        label: "DJ Equipment",
      },
      {
        category: IEquipmentCategory.soundMiscellaneous,
        label: "Miscellaneous",
      },
    ],
  },
  {
    category: IEquipmentCategory.light,
    label: "Light Equipment",
    slug: "light-equipment",
    categories: [
      {
        category: IEquipmentCategory.lightLightDesk,
        label: "Light Desk",
      },
      {
        category: IEquipmentCategory.lightIntelligentLights,
        label: "Intelligent Lights",
      },
      {
        category: IEquipmentCategory.lightConventionalLights,
        label: "Conventional Lights",
      },
      {
        category: IEquipmentCategory.lightDimmers,
        label: "Dimmers",
      },
      {
        category: IEquipmentCategory.lightFollowSpots,
        label: "Follow Spots",
      },
      {
        category: IEquipmentCategory.lightSpecials,
        label: "Specials",
      },
      {
        category: IEquipmentCategory.lightSmoke,
        label: "Smoke",
      },
      {
        category: IEquipmentCategory.lightHaze,
        label: "Haze",
      },
      {
        category: IEquipmentCategory.lightFX,
        label: "FX",
      },
      {
        category: IEquipmentCategory.lightMiscellaneous,
        label: "Miscellaneous",
      },
    ],
  },
  {
    category: IEquipmentCategory.video,
    label: "Video Equipment",
    slug: "video-equipment",
    categories: [
      {
        category: IEquipmentCategory.videoProjector,
        label: "Projector",
      },
      {
        category: IEquipmentCategory.videoProjectionScreen,
        label: "Projection Screen",
      },
      {
        category: IEquipmentCategory.videoLEDScreen,
        label: "LED Screen",
      },
      {
        category: IEquipmentCategory.videoVideoMixer,
        label: "Video Mixer",
      },
      {
        category: IEquipmentCategory.videoMiscellaneous,
        label: "Miscellaneous",
      },
    ],
  },
];

// Equipment by key
export const equipmentCategoryMap = keyBy(equipmentCategoryList, "category");

export const getEquipmentCategories = (asMap = false) =>
  asMap ? equipmentCategoryMap : equipmentCategoryList;

export const EquipmentSubCategoryMap: {
  [key: string]: IEquipmentSubcategoryItem;
} = equipmentCategoryList.reduce(
  (acc, { categories }) => ({ ...acc, ...keyBy(categories, "category") }),
  {}
);

export const getEquipmentMainCategory = (
  key: IEquipmentCategory
): IEquipmentCategoryItem | undefined => {
  const keys = words(key);
  return equipmentCategoryMap[keys?.[0]];
};

export const getEquipmentSubCategory = (
  key: IEquipmentCategory
): IEquipmentSubcategoryItem | undefined => {
  return EquipmentSubCategoryMap[key];
};
